import { PatientsListTypes } from 'consts/copilotControlConsts'
import NeedsAttentionList from '../CopilotPatientsLists/NeedsAttentionList/NeedsAttentionList'
import PatientsSentimentList from '../CopilotPatientsLists/PatientsSentimentList/PatientsSentimentList'
import PatientsScanningScheduleList from './PatientsScanningScheduleList/PatientsScanningScheduleList'

const PatientsListPicker = ({ type }) => {
  switch (type) {
    case PatientsListTypes.NeedsAttention.type:
      return <NeedsAttentionList />
    case PatientsListTypes.PatientsSentiment.type:
      return <PatientsSentimentList />
    case PatientsListTypes.ScanningSchedule.type:
      return <PatientsScanningScheduleList />
    default:
      return <NeedsAttentionList />
  }
}

export default PatientsListPicker
